module.exports = __webpack_public_path__ + "static/media/eu.bf355e20.png";